import { concat, filter, forEach, isArray, isArrayLike, isEmpty, isNil, isPlainObject, isString, map, split, toArray, trim } from 'lodash';

const isDomElement = (el) => {
    return (el instanceof Node) || (el instanceof NodeList);
};
const getDomOffset = (a, b) => {
    if (!isDomElement(a) || !isDomElement(b)) {
        return;
    }
    const aRect = a.getBoundingClientRect();
    const bRect = b.getBoundingClientRect();
    return {
        left: aRect.left - bRect.left,
        top: aRect.top - bRect.top,
        right: aRect.right - bRect.right,
        bottom: aRect.bottom - bRect.bottom
    };
};

export const getFilesFromEvent = (e) => {
    if (e.nativeEvent) {
        e = e.nativeEvent;
    }

    /**
     * 粘贴复制方式获取数据源 clipboardData
     * 拖拽复制方式获取数据源 dataTransfer
     */
    const transfer = e.clipboardData || e.dataTransfer;
    if (!transfer) {
        return [];
    }
    if (!isEmpty(transfer.files)) {
        return toArray(transfer.files);
    }
    if (!isEmpty(transfer.items)) {
        const fileItems = filter(transfer.items, (item) => {
            return item.kind === 'file';
        });
        return map(fileItems, (item) => item.getAsFile());
    }
    return [];
};


/**
 * 是否在划词
 * @returns {boolean}
 */
export const hasSelection = () => {
    try {
        const txt = window.getSelection ? window.getSelection() : document.selection.createRange().text;
        return txt.type === 'Range'
    } catch (e) {
        return false
    }
}

/**
 * DOM元素重排
 * @param elem
 */
const forceReLayout = (elem) => {
    const $elemParent = elem.parentNode;
    const originalStyle = elem.style.display;
    const originalHeight = $elemParent.style.height;
    $elemParent.style.height = elem.offsetHeight + 'px';
    elem.style.display = 'none';
    if (!isNil(elem.offsetHeight)) {
        elem.style.display = originalStyle;
        $elemParent.style.height = originalHeight;
    }
};

const parseClassNames = (classNames) => {
    classNames = isArray(classNames) ? classNames : [classNames];
    let result = [];
    forEach(classNames, (cls) => {
        const parts = split(trim(cls), /\s+/);
        result = concat(result, parts);
    });
    return result;
};

const removeClass = ($el, classNames) => {
    if (!isDomElement($el) || isNil(classNames)) {
        return;
    }
    classNames = parseClassNames(classNames);
    $el = isArrayLike($el) ? $el : [$el];
    forEach(classNames, (cls) => {
        if (!cls) {
            return;
        }
        forEach($el, ($item) => {
            ($item).classList.remove(cls);
        });
    });
};
const addClass = ($el, classNames) => {
    if (!isDomElement($el) || isNil(classNames)) {
        return;
    }
    classNames = parseClassNames(classNames);
    $el = isArrayLike($el) ? $el : [$el];
    forEach(classNames, (cls) => {
        if (!cls) {
            return;
        }
        forEach($el, ($item) => {
            ($item).classList.add(cls);
        });
    });
};

const hasClass = ($el, className) => {
    if (!isDomElement($el) || !isString(className)) {
        return false;
    }

    return ($el).classList.contains(className);
};

const setAttr = ($el, attr, value) => {
    if (!isDomElement($el)) {
        return;
    }
    $el = isArrayLike($el) ? $el : [$el];
    attr = isPlainObject(attr) ? attr : {[attr]: value};
    forEach(attr, (v, name) => {
        forEach($el, ($item) => {
            $item.setAttribute(name, v);
        });
    });
};

const closest = ($el, selector) => {
    if (!isDomElement($el)) {
        return null;
    }
    if (isDomElement(selector)) {
        let $element = $el;

        while ($element) {
            if ($element === selector) {
                return $element;
            }
            $element = $element.parentElement;
        }
        return null;
    }

    if ($el.closest) {
        return $el.closest(selector);
    }

    const matchesSelector = $el.matches || $el.webkitMatchesSelector || $el.mozMatchesSelector || $el.msMatchesSelector;

    if (!matchesSelector) {
        return null;
    }

    let $element = $el;

    while ($element) {
        if (matchesSelector.call($element, selector)) {
            return $element;
        }
        $element = $element.parentElement;
    }
    return null;
};

const isTextNode = ($el) => {
    return $el.nodeType === 3;
};

const getDOMStyle = (element, prop) => {
    if (window.getComputedStyle) {
        return getComputedStyle(element, null).getPropertyValue(prop);
    }
    return element.style[prop];
};

const getScrollParent = (element) => {

    if (!(element instanceof HTMLElement)) {
        return window;
    }

    let parent = element;

    while (parent) {
        if (parent === document.body || parent === document.documentElement) {
            break;
        }

        const overflow = getDOMStyle(parent, 'overflow') + getDOMStyle(parent, 'overflow-y') + getDOMStyle(parent, 'overflow-x');

        if (/(scroll|auto)/.test(overflow)) {
            return parent;
        }

        if (!parent.parentNode) {
            break;
        }

        parent = parent.parentNode;
    }

    return window;
};

export {
    isDomElement,
    getDomOffset,
    removeClass,
    addClass,
    hasClass,
    setAttr,
    closest,
    forceReLayout,
    isTextNode,
    getScrollParent
}
